import { useState, Fragment } from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import { contactTypes } from "../../../enum/contactTypes";
import { MdOutlineContentCopy } from "react-icons/md";
import { Tooltip, Skeleton } from "@mui/material";

export default function Contact() {
  const { patientState, appState } = useTitanApp();
  const { darkMode } = appState || {};
  const { selectedPatientDetails, isPatientDetailsLoading } = patientState || {};
  const contactDetails = [];
  const [copiedIndex, setCopiedIndex] = useState(null);

  if (selectedPatientDetails) {
    contactDetails.push({
      label: "Email",
      value: selectedPatientDetails?.email || "",
    });
    selectedPatientDetails.contacts?.forEach((contact) => {
      if (contact?.value) {
        contactDetails.push({
          label: contactTypes[contact.contactType],
          value: contact.value,
        });
      }
    });
  }

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 1500);
    });
  };

  return (
    <Fragment>
      <div className="tasks_header">
        <h3 className="pharmacy_header_name">Contact Details</h3>
        {/* {darkMode ? <AddNewLightSvg /> : <AddNewDarkSvg />} */}
      </div>
      <div className="contact-details-wrapper">
        {contactDetails?.map((contact, index) => (
          <div className="contact-detail-box" key={index}>
            <div>
              <p className="contact-label">{contact.label}</p>
              {isPatientDetailsLoading ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={30}
                  sx={{
                    width: {
                      xs: '250px',
                      sm: '250px',
                      md: '130px',
                      lg: '250px',
                      xl: '350px'
                    },
                    bgcolor: darkMode ? "grey.800" : "",
                    borderRadius: "5px"
                  }}
                />
              ) : (
                <p className="contact-value">{contact.value}</p>
              )}
            </div>
            <Tooltip title={copiedIndex === index ? "Copied!" : "Copy"} arrow>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(contact.value, index);
                }}
              >
                <MdOutlineContentCopy
                  size={22}
                  className="patient-dashboard-icons-color copy-icon"
                />
              </div>
            </Tooltip>
          </div>
        ))}
      </div>
    </Fragment>
  );
}
